import React, { createContext, useReducer, useEffect } from "react";
import AppReducer from "./AppReducer";
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

// initial state
const initialState = {
  watchlist: localStorage.getItem("watchlist")
    ? JSON.parse(localStorage.getItem("watchlist"))
    : [],
  watched: localStorage.getItem("watched")
    ? JSON.parse(localStorage.getItem("watched"))
    : [],
};

// create context
export const GlobalContext = createContext(initialState);

// provider components
export const GlobalProvider = (props) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);

  useEffect(() => {
    localStorage.setItem("watchlist", JSON.stringify(state.watchlist));
    localStorage.setItem("watched", JSON.stringify(state.watched));
  }, [state]);

  // actions
  const addMovieToWatchlist = (movie) => {
    dispatch({ type: "ADD_MOVIE_TO_WATCHLIST", payload: movie });
    setOpenAdd(true)
  };

  const removeMovieFromWatchlist = (id) => {
    dispatch({ type: "REMOVE_MOVIE_FROM_WATCHLIST", payload: id });
    setOpenRemove(true)
  };

  const addMovieToWatched = (movie) => {
    dispatch({ type: "ADD_MOVIE_TO_WATCHED", payload: movie });
    setOpenAdd(true)
  };

  const moveToWatchlist = (movie) => {
    dispatch({ type: "MOVE_TO_WATCHLIST", payload: movie });
  };

  const removeFromWatched = (id) => {
    dispatch({ type: "REMOVE_FROM_WATCHED", payload: id });
    setOpenRemove(true)
  };

  const [openAdd, setOpenAdd] = React.useState(false);
  const [openRemove, setOpenRemove] = React.useState(false);

  const handleCloseAdd = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAdd(false);
  };
  const handleCloseRemove = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenRemove(false);
  };
  return (
    <GlobalContext.Provider
      value={{
        watchlist: state.watchlist,
        watched: state.watched,
        addMovieToWatchlist,
        removeMovieFromWatchlist,
        addMovieToWatched,
        moveToWatchlist,
        removeFromWatched,
      }}
    >
      {props.children}
      <Snackbar open={openAdd} autoHideDuration={6000} onClose={handleCloseAdd} anchorOrigin={{ vertical:"top", horizontal:"center" }}>
        <Alert onClose={handleCloseAdd} severity="success">
          <span className="font-large">Movie Added</span>
        </Alert>
      </Snackbar>
      <Snackbar open={openRemove} autoHideDuration={6000} onClose={handleCloseRemove} anchorOrigin={{ vertical:"top", horizontal:"center" }}>
        <Alert onClose={handleCloseRemove} severity="success">
          <span className="font-large">Movie removed</span>
        </Alert>
      </Snackbar>
    </GlobalContext.Provider>
  );
};
